import moment from "moment";
import { PPInput, PPMultiSelect, PPTextField, PPToggle } from "processor-plataform-ui";
import React, { useEffect, useState } from "react";
import HHExpand from "../../../../components/Generic/HHExpand";
import LcDropDown from "../../../../components/Generic/LcDropDown";
import LcIconLink from "../../../../components/Generic/LcIconLink";
import { SolicitationFilterDashboard } from "../../../../models/SolicitationFilter";
import TextTools from "../../../../services/TextTools/TextTools";
import SolicitationAttendantService from "../../../../services/SolicitationAttendantService/SolicitationAttendantService";
import BusinessAreaService from "../../../../services/BusinessAreaService/BusinessAreaService";
import { SolicitationAttendantFilter } from "../../../../models/SolicitationAttendantFilter";
import SideModal from "../../../../components/Layout/SideModal/SideModal";
import LcLoading from "../../../../components/Generic/LcLoading";
import LcInfiniteTable from "../../../../components/Data/LcInfiniteTable";
import Modal from "../../../../components/Dialog/Modal";
import { Validate } from "../../../../models/Validate";
import { useDispatch, useSelector } from "react-redux";
import { PrefState } from "../../../../store/reducers/prefReducer";
import { MenuState } from '../../../../store/reducers/menuReducer';
import { RootState } from "../../../../store";
import BusinessUnitService from "../../../../services/BusinessUnitService/BusinessUnitService";
import CustomerService from "../../../../services/CustomerService/CustomerService";
import ServiceGroupService from "../../../../services/ServiceGroupService/ServiceGroupService";
import ProcessService from "../../../../services/ProcessService/ProcessService";
import ServiceService from "../../../../services/ServiceService/ServiceService";
import WorkTeamService from "../../../../services/WorkTeamService/WorkTeamService";
import atendentService from "../../../../services/HeyHoUserService/HeyHoUserService";
import { periodState } from "../../../../models/Period";
import LcIcon from "../../../../components/Generic/LcIcon";
import "./index.css";
import LcTooltip from "../../../../components/Generic/LcTooltip";

interface Props {
    setCurrentFilter: Function
    currentFilter: SolicitationFilterDashboard
    setBusinessAreaList: Function
    setCustomerFullList: Function
    user: any
    clear: boolean
    setClear: Function
    toggle: boolean
    setLoading: Function
    loading: boolean
}

const DashboardFilters: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);

    const businessUnitService = new BusinessUnitService(props);
    const customerService = new CustomerService(props);
    const serviceGroupService = new ServiceGroupService(props);
    const serviceService = new ServiceService(props);
    const processService = new ProcessService(props);
    const workTeamService = new WorkTeamService(props);
    const attedantService = new atendentService(props);
    const businessAreaService = new BusinessAreaService(props);

    const textTools = new TextTools();
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();
    const diaFinalMesInicial = new Date(new Date().getFullYear(), (new Date().getMonth() + 1), 0).getDate();

    const getFilterDefault = (): SolicitationFilterDashboard => {
        return {
            businessAreaId: 0,
            customerIds: [],
            teamIds: [],
            attendantIds: [],
            statusIds: [],
            incidentIds: [],
            processIds: [],
            groupServiceIds: [],
            serviceIds: [],
            dataInicio: moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + 1 + " 00:00").format("YYYY-MM-DDTHH:mm:ss"),
            dataFinal: moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + diaFinalMesInicial + " 23:59").format("YYYY-MM-DDTHH:mm:ss"),
            dateTypes: [1],
            assunto: "0",
            typeTotalResult: 0,
            tipoProcesso: null,
            modoAbertura: null,
            solicitante: null,
            take: 0,
            skip: 0,
            userIds: props.user.id ?? 0,
            isCurrent: false
        }
    }

    const [currentFilter, setCurrentFilter] = React.useState<any>(getFilterDefault());
    const [filtersList, setFiltersList] = React.useState<any>([]);
    const [openModalFilter, setOpenModalFilter] = React.useState(false);
    const [loadingFilters, setLoadingFilters] = React.useState<boolean>(false);
    const [openNameFilter, setOpenNameFilter] = React.useState(false);
    const [validations, setValidations] = React.useState<Validate[]>([]);
    const [loadingSaveFilter, setLoadingSaveFilter] = React.useState(false);
    const [newNameFilter, setNewNameFilter] = React.useState("");
    const [businessAreaList, setBusinessAreaList] = useState<any[]>([]);
    const [customerList, setCustomerList] = useState<any[]>([]);
    const [customerFullList, setCustomerFullList] = useState<any[]>([]);
    const [serviceGroupList, setServiceGroupList] = useState<any[]>([]);
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [processList, setProcessList] = useState<any[]>([]);
    const [allWorkTeam, setAllWorkTeam] = useState<any[]>([]);
    const [attendantList, setAttendantList] = useState<any[]>([]);
    const [clear, setClear] = useState<boolean>(false);
    const [toggle, setToggle] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingCustomer, setLoadingCustomer] = useState<boolean>(false);
    const [loadingServiceGroup, setLoadingServiceGroup] = useState<boolean>(false);
    const [loadingService, setLoadingService] = useState<boolean>(false);
    const [loadingProcess, setLoadingProcess] = useState<boolean>(false);
    const [loadingTeams, setLoadingTeams] = useState<boolean>(false);
    const [loadingAttendants, setLoadingAttendants] = useState<boolean>(false);
    const [initRender, setInitRender] = useState<boolean>(false);

    const defaultPeriods = [
        {
            label: "Competência",
            value: 0,
            selected: (pref.competenceDash) ? true : false
        },
        {
            label: "Solicitação",
            value: 1,
            selected: true
        },
        {
            label: "Conclusão",
            value: 2,
        },
        {
            label: "Encerramento",
            value: 3,
        }
    ];

    const [periodDate, setPeriodDate] = useState<periodState[]>(defaultPeriods);

    const filterColumns = [
        {
            field: "name",
            headerName: "Descrição",
            width: "88%",
            renderCell: (row: any) => <span style={{ cursor: "pointer" }} onClick={() => applySelectedFilter(JSON.parse(row.json))}>{row.name}</span>
        },
        {
            field: "",
            headerName: "",
            align: "right",
            overFlow: "visible",
            width: "12%",
            renderCell: (row: any) => <LcIconLink icon="ppi ppi-trash" onClick={() => deleteFilter(row.id)} tooltip={"Excluir filtro"} />
        },
    ];

    const applySelectedFilter = (_filter: any) => {
        dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "filterSelected", value: _filter } });
        setCurrentFilter(_filter);
        if (openModalFilter) setOpenModalFilter(false);
    }

    useEffect(() => {
        if (props.user) {
            Init();
        }
    }, [])

    useEffect(() => {
        if (props.user && currentFilter && !initFilter) {
            let _customerList = refreshList(customerList, currentFilter.customerIds ?? [], true);
            setCustomerList(_customerList);
            getServiceGroup();
            // getAllTeams();
        }
    }, [currentFilter?.customerIds])

    useEffect(() => {
        if (props.user && currentFilter && !initFilter) {
            getServiceList();
        }
    }, [currentFilter?.groupServiceIds])

    useEffect(() => {
        if (props.user && currentFilter && !initFilter) {
            getProcessList();
        }
    }, [currentFilter?.serviceIds])

    useEffect(() => {
        if (props.user && currentFilter && !initFilter) {
            getAttendants();
        }
    }, [currentFilter?.teamIds])

    useEffect(() => {
        getCustomerList();
        getServiceGroupAll();
        getAllTeams();
    }, [pref.businessAreaDash]);

    useEffect(() => {
        if (pref.solicitationTypeDash) {
            const dataAtual = new Date();

            let filter = currentFilter;

            if (pref.solicitationTypeDash === "all") {
                const diaFinalMesInicial = new Date(new Date().getFullYear(), (new Date().getMonth() + 1), 0).getDate();
                const dataInicial = moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + 1 + " 00:00").format("YYYY-MM-DDTHH:mm:ss");
                const dateFinal = moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + diaFinalMesInicial + " 23:59").format("YYYY-MM-DDTHH:mm:ss");

                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, idStatus: "111" };
            }
            else if (pref.solicitationTypeDash === "today") {
                const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
                const dateFinal = moment(dataAtual).add(1, "day").format("YYYY-MM-DD");

                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0", idStatus: "111" };
            }
            else if (pref.solicitationTypeDash === "week") {
                const dataInicial = moment(dataAtual).day(0).format("YYYY-MM-DD");
                const dateFinal = moment(dataAtual).day(6).format("YYYY-MM-DD");

                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0", idStatus: "111" };
            }
            else if (pref.solicitationTypeDash === "month") {
                const dateFirstDay = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
                const dataInicial = moment(dateFirstDay).format("YYYY-MM-DD");
                const dateFinal = moment(dataInicial).add(1, "month").subtract(1, "day").format("YYYY-MM-DD");

                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0", idStatus: "111" };
            }
            else if (pref.solicitationTypeDash === "lastMonth") {
                const diaFinalMesAnterior = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 0).getDate();

                const dateFirstDay = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
                const dataInicial = moment(dateFirstDay).subtract(1, "month").format("YYYY-MM-DD");
                const dateFinal = moment(dataAtual.getFullYear() + "/" + (dataAtual.getMonth()) + "/" + diaFinalMesAnterior).format("YYYY-MM-DD");

                filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0", idStatus: "111" };
            }

            setCurrentFilter(filter);
            applyFilters(filter);
        }
    }, [pref.solicitationTypeDash]);

    useEffect(() => {
        if (initRender) {
            const _currentFilter = {
                ...currentFilter,
                businessAreaId: pref.businessAreaDash ?? 0
            };

            setCurrentFilter(_currentFilter)
            applyFilters(_currentFilter);
        }
    }, [pref.businessAreaDash])

    useEffect(() => {
        if (initRender) {
            let _currentFilter = currentFilter;

            if (pref.competenceDash) {
                const date = new Date(moment(pref.competenceDash + "-01").format("YYYY-MM-DDTHH:mm:ss"));
                const diaFinalMesCompetencia = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

                _currentFilter = {
                    ..._currentFilter,
                    dateTypes: [0],
                    dataInicio: moment(pref.competenceDash + "-01").format("YYYY-MM-DDTHH:mm:ss"),
                    dataFinal: moment(pref.competenceDash + "-" + diaFinalMesCompetencia).format("YYYY-MM-DDTHH:mm:ss"),
                };

                const _periodDate = periodDate.map(x => {
                    // if (x.label === "Competência") {
                    //     return {
                    //         ...x,
                    //         selected: true
                    //     }
                    // }
                    // else {
                    //     return {
                    //         ...x,
                    //         selected: false
                    //     }
                    // }

                    return {
                        ...x,
                        selected: (x.value === 0)
                    }
                })

                setPeriodDate(_periodDate);
            }
            else {
                _currentFilter = {
                    ..._currentFilter,
                    dateTypes: [1],
                    dataInicio: moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + 1 + " 00:00").format("YYYY-MM-DDTHH:mm:ss"),
                    dataFinal: moment(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + diaFinalMesInicial + " 23:59").format("YYYY-MM-DDTHH:mm:ss"),
                };

                const _periodDate = periodDate.map(x => {
                    // if (x.label === "Solicitação") { 
                    //     return {
                    //         ...x,
                    //         selected: true
                    //     }
                    // }
                    // else {
                    //     return {
                    //         ...x,
                    //         selected: false
                    //     }
                    // }

                    return {
                        ...x,
                        selected: (x.value === 1)
                    }
                })

                setPeriodDate(_periodDate);
            }

            setCurrentFilter(_currentFilter)
            applyFilters(_currentFilter);
        }
    }, [pref.competenceDash, initRender])

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if (!(newNameFilter.length > 0)) {
            validationsChecks.push({
                name: "name",
                validateMessage: "Deve possuir um nome válido.",
                valid: false
            });
        }

        setValidations(validationsChecks);
        return validationsChecks.length == 0;
    }

    const getFilters = async () => {
        setLoadingFilters(true);

        try {
            const solicitationAttendanteResponse = await solicitationAttendantService.SelectAttendantFilters(Number(props.user.id));
            const filteredDashboard = solicitationAttendanteResponse.data.filter((item: SolicitationAttendantFilter) => item.origem === "dashboard");
            setFiltersList(filteredDashboard);
        }
        catch (error) {
            debugger
            console.warn(error);
        }

        setLoadingFilters(false);
    }

    // const [initFilter, setInitFilter] = useState<boolean>(pref.dataLocal?.filterSelected ? true : false);
    const [initFilter, setInitFilter] = useState<boolean>(false);

    const Init = async () => {
        // var _filterSelected = pref.dataLocal?.filterSelected;
        setInitRender(true);

        try {
            await getBusinessAreaList();
            await getCustomerList();
            await getServiceGroupAll();
            await getAllTeams();
            await getFilters();

            // if (_filterSelected) {
            //     setCurrentFilter(_filterSelected);
            // }
        }
        catch (error) {
            debugger
        }

        setInitFilter(false);
    }

    const refreshList = (list: any[], selected: any[], select?: boolean) => {
        let refresh = list.map(field => {
            let filter = selected.find(i => i === field.value);

            if (filter) {
                return {
                    ...field,
                    selected: (select) ? true : false
                }
            }
            else {
                return {
                    ...field,
                    selected: false
                }
            }
        })

        return refresh;
    }

    useEffect(() => {
        setClear(props.clear);
    }, [props.clear])

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading])

    useEffect(() => {
        if (clear) {
            let customer = refreshList(customerList, currentFilter.customerIds);
            let GroupList = refreshList(serviceGroupList, currentFilter.groupServiceIds);
            let service = refreshList(serviceList, currentFilter.serviceIds);
            let process = refreshList(processList, currentFilter.processIds);
            let team = refreshList(allWorkTeam, currentFilter.teamIds);
            let attendant = refreshList(attendantList, currentFilter.attendantIds);

            setCustomerList([...customer]);
            setServiceGroupList([...GroupList]);
            setServiceList([...service]);
            setProcessList([...process]);
            setAllWorkTeam([...team]);
            setAttendantList([...attendant]);
            setPeriodDate(defaultPeriods);

            props.setClear(false);
            setClear(false);

            setCurrentFilter(getFilterDefault());
            dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "filterSelected", value: undefined } });

            dispatch({ type: "PREF_BUSINESSAREA_DASH", payload: null });
            dispatch({ type: "PREF_SOLICITATIONTYPE_DASH", payload: null });
            dispatch({ type: "PREF_COMPETENCE_DASH", payload: null });

            applyFilters(getFilterDefault());
        }
    }, [clear])

    const handleSelect = (event: any, currentFilterList: any[]) => {
        if (event && event.target) {
            const { name, value } = event.target;
            let valueList = value.map(i => i.value);

            if (!textTools.compareArrays(valueList, currentFilterList)) {
                setCurrentFilter((prevState) => {
                    let _valueList = value.map(i => i.value);

                    if (name === "dateTypes" && _valueList.length === 0) {
                        return {
                            ...prevState,
                            dateTypes: [1]
                        };
                    }

                    return {
                        ...prevState,
                        [name]: _valueList,
                    };
                });
            }
        }
    }

    const handleDate = (event: any) => {
        if (event && event.target) {
            const { name, value } = event.target;

            setCurrentFilter({
                ...currentFilter,
                [name]: moment(value).format("YYYY-MM-DD")
            });
        }
    }

    const handleSelectedFilter = (filter: any, nameFilter: string, type: string) => {
        if (type === "insert" || type === "update") {
            saveFilter(filter, nameFilter);
        }
        else if (type === "delete") {
            deleteFilter(filter.id);
        }
        else if (type === "select") {
            applySelectedFilter(JSON.parse(filter.json))
        }
    }

    const saveFilter = async (filter: any, nameFilter: string) => {
        setLoadingFilters(true);

        filter = { ...filter, dataInicio: null, dataFinal: null, TipoData: "0", idStatus: "111" };

        let _filter: any = {
            IdUser: Number(props.user.id),
            Name: nameFilter,
            Json: JSON.stringify(filter),
            origem: "dashboard"
        }

        var _filterSelected = pref.dataLocal?.filterSelected ?? {};

        let filterUpdate = filtersList.find(element => element.id === _filterSelected.id);

        if (filterUpdate) {
            _filter = {
                ..._filter,
                id: filterUpdate?.id
            }
        }

        try {
            await solicitationAttendantService.SaveFilter(_filter);
            getFilters();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingFilters(false);
    }

    const deleteFilter = async (filterId: number) => {
        setLoadingFilters(true);

        try {
            await solicitationAttendantService.DeleteAttendantFilter(filterId);
            getFilters();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingFilters(false);
    }

    const submitFilter = () => {
        if (validateRules() === false) {
            return true;
        }

        setLoadingSaveFilter(true);

        let operation = "";

        if (filtersList.length > 0) {
            let update = filtersList.filter(element => element.name === newNameFilter)
            operation = (update.length > 0) ? "update" : "insert";
        }
        else {
            operation = "insert";
        }

        handleSelectedFilter(currentFilter, newNameFilter, operation);

        setLoadingSaveFilter(false);
        setOpenNameFilter(false);
    }

    useEffect(() => {
        if (openNameFilter) {
            var _filterSelected = pref.dataLocal?.filterSelected ?? {};
            let _filter = filtersList.find(element => element.id === _filterSelected.id);
            setNewNameFilter((_filter && _filter.name) ? _filter.name : "");
        }
    }, [openNameFilter]);

    const getBusinessAreaList = async () => {
        try {
            var businessResponse = await businessAreaService.getByUserId(props.user.id);
            setBusinessAreaList(businessResponse.data);
            props.setBusinessAreaList(businessResponse.data);
        }
        catch (error) {
            debugger;
        }
    };

    // const getCustomerList = async (_filterSelected?: any) => {
    const getCustomerList = async () => {
        setLoadingCustomer(true);

        try {
            // var _filter = (_filterSelected) ? _filterSelected : currentFilter;

            var _customerFullList: any[] = []

            let customerResponse = await customerService.getByUserId(props.user.id, (pref.businessAreaDash) ? pref.businessAreaDash : 0);
            _customerFullList = customerResponse.data;

            setCustomerFullList(customerResponse.data);
            props.setCustomerFullList(customerResponse.data);
            const allCustomer = textTools.filterSelectedList(customerResponse.data, (currentFilter) ? currentFilter.customerIds : []);

            setCustomerList(allCustomer);

            // if (_filterSelected && _filterSelected.customerIds.length > 0) {
            //     await getServiceGroup(_filterSelected, _customerFullList);
            //     await getAllTeams(_filterSelected);
            // }
        }
        catch (error) {
            console.error(error);
            debugger;
        }

        setLoadingCustomer(false);
    };

    // const getServiceGroup = async (_filterSelected?: any, _customerFullList?: any[]) => {
    const getServiceGroupAll = async () => {
        setLoadingServiceGroup(true);

        try {
            let resultList: any[] = [];

            // var _filter = (_filterSelected) ? _filterSelected : currentFilter;
            var _filter = currentFilter;

            // await _filter.customerIds.reduce(async (previousPromise, customerId) => {
            //     try {
            //         const _resultList = await previousPromise;

            //         let serviceGroupResponse = await serviceGroupService.GetUserAttendantFilter(props.user.id, customerId);

            //         if (serviceGroupResponse) {
            //             const allserviceGroup = textTools.filterSelectedList(serviceGroupResponse.data, (_filter) ? _filter.groupServiceIds : []);
            //             resultList = [...resultList, ...allserviceGroup];
            //         }

            //         return _resultList;
            //     }
            //     catch (error) {
            //         debugger
            //         return [];
            //     }
            // }, Promise.resolve([]));

            let serviceGroupResponse = await serviceGroupService.GetByManager(props.user.id);

            if (serviceGroupResponse) {
                const allserviceGroup = textTools.filterSelectedList(serviceGroupResponse.data, (_filter) ? _filter.groupServiceIds : []);
                resultList = [...resultList, ...allserviceGroup];
            }

            resultList = resultList
                .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                .sort((a, b) => (a.label > b.label ? 1 : -1));

            setServiceGroupList(resultList);

            // if (_filterSelected && _filterSelected.groupServiceIds.length > 0) {
            //     await getServiceList(_filterSelected);
            // }

            await getServiceList();
        }
        catch (error) {
            console.error(error);
            debugger;
        }

        setLoadingServiceGroup(false);
    }


    const getServiceGroup = async (_filterSelected?: any, _customerFullList?: any[]) => {
        setLoadingServiceGroup(true);

        try {
            let resultList: any[] = [];

            var _filter = (_filterSelected) ? _filterSelected : currentFilter;

            if (_filter.customerIds.length === 0) {
                getServiceGroupAll();
            }
            else {
                await _filter.customerIds.reduce(async (previousPromise, customerId) => {
                    try {
                        const _resultList = await previousPromise;

                        let serviceGroupResponse = await serviceGroupService.GetUserAttendantFilter(props.user.id, customerId);

                        if (serviceGroupResponse) {
                            const allserviceGroup = textTools.filterSelectedList(serviceGroupResponse.data, (_filter) ? _filter.groupServiceIds : []);
                            resultList = [...resultList, ...allserviceGroup];
                        }

                        return _resultList;
                    }
                    catch (error) {
                        debugger
                        return [];
                    }
                }, Promise.resolve([]));

                resultList = resultList
                    .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                    .sort((a, b) => (a.label > b.label ? 1 : -1));

                setServiceGroupList(resultList);

                if (_filterSelected && _filterSelected.groupServiceIds.length > 0) {
                    await getServiceList();
                }

                await getServiceList();
            }
        }
        catch (error) {
            console.error(error);
            debugger;
        }

        setLoadingServiceGroup(false);
    }

    // const getServiceList = async (_filterSelected?: any) => {
    const getServiceList = async () => {
        setLoadingService(true);

        try {
            // var _filter = (_filterSelected) ? _filterSelected : currentFilter;
            var _filter = currentFilter;

            let resultList: any[] = [];

            await _filter.groupServiceIds.reduce(async (previousPromise, groupServiceId) => {
                try {
                    const _resultList = await previousPromise;

                    var serviceResponse = props.user.id && await serviceService.GetByServiceGroupFilter(groupServiceId);

                    if (serviceResponse) {
                        const allservice = textTools.filterSelectedList(serviceResponse.data, (_filter) ? _filter.serviceIds : []);
                        resultList = [...resultList, ...allservice];
                    }

                    return _resultList;
                }
                catch (error) {
                    debugger
                    return [];
                }
            }, Promise.resolve([]));

            resultList = resultList
                .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                .sort((a, b) => (a.label > b.label ? 1 : -1));

            setServiceList(resultList);

            await getProcessList();

            // if (_filterSelected && _filterSelected.serviceIds.length > 0) {
            //     await getProcessList(_filterSelected);
            // }
        }
        catch (error) {
            console.error(error);
            // debugger;
        }

        setLoadingService(false);
    }

    const getProcessList = async (_filterSelected?: any) => {
        setLoadingProcess(true);

        try {
            var _filter = (_filterSelected) ? _filterSelected : currentFilter;

            let resultList: any[] = [];

            await _filter.serviceIds.reduce(async (previousPromise, serviceId) => {
                try {
                    const _resultList = await previousPromise;

                    var processResponse = await processService.getProcessbyService(serviceId);

                    if (processResponse) {
                        const allprocess = textTools.filterSelectedList(processResponse.data, (_filter) ? _filter.processIds : []);
                        resultList = [...resultList, ...allprocess];
                    }

                    return _resultList;
                }
                catch (error) {
                    debugger
                    return [];
                }
            }, Promise.resolve([]));

            resultList = resultList
                .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                .sort((a, b) => (a.label > b.label ? 1 : -1));

            setProcessList(resultList);
        }
        catch (error) {
            console.error(error);
            // debugger;
        }

        setLoadingProcess(false);
    };

    // const getAllTeams = async (_filterSelected?: any) => {
    const getAllTeams = async () => {
        setLoadingTeams(true);

        try {
            // var _filter = (_filterSelected) ? _filterSelected : currentFilter;
            var _filter = currentFilter;

            let resultList: any[] = [];

            // await _filter.customerIds.reduce(async (previousPromise, customerId) => {
            //     try {
            //         const _resultList = await previousPromise;

            //         var teamsResponse = await workTeamService.GetWorkTeambyUserCustomerId(Number(props.user.id), customerId + "");

            //         if (teamsResponse) {
            //             const allTeams = textTools.filterSelectedList(teamsResponse.data, (_filter) ? _filter.teamIds : []);
            //             resultList = [...resultList, ...allTeams];
            //         }

            //         return _resultList;
            //     }
            //     catch (error) {
            //         debugger
            //         return [];
            //     }
            // }, Promise.resolve([]));


            var teamsResponse = await workTeamService.GetWorkTeambyUser(Number(props.user.id));

            if (teamsResponse) {
                const allTeams = textTools.filterSelectedList(teamsResponse.data, (_filter) ? _filter.teamIds : []);
                resultList = [...resultList, ...allTeams];
            }

            resultList = resultList
                .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                .sort((a, b) => (a.label > b.label ? 1 : -1));

            setAllWorkTeam(resultList);

            // if (_filterSelected && _filterSelected.teamIds.length > 0) {
            //     await getAttendants(_filterSelected);
            // }

            await getAttendants();
        }
        catch (e) {
            console.error(e);
            // debugger;
        }

        setLoadingTeams(false);
    };

    const getAttendants = async (_filterSelected?: any) => {
        setLoadingAttendants(true);

        try {
            // var _filter = (_filterSelected) ? _filterSelected : currentFilter;
            var _filter = currentFilter;

            let resultList: any[] = [];

            // await _filter.teamIds.reduce(async (previousPromise, teamId) => {
            // try {
            //     // const _resultList = await previousPromise;

            //     var response = await attedantService.GetUsersAttendantMulti(props.user.id, 0, "0");

            //     if (response) {
            //         const allAtendants = textTools.filterSelectedList(response.data, (_filter) ? _filter.attendantIds : []);
            //         resultList = [...resultList, ...allAtendants];
            //     }


            //     resultList = resultList
            //     .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
            //     .sort((a, b) => (a.label > b.label ? 1 : -1));

            //     setAttendantList(resultList);

            //     return resultList;
            // }
            // catch (error) {
            //     debugger
            //     return [];
            // }

            // }, Promise.resolve([]));

            var response = await attedantService.GetUsersAttendantMulti(props.user.id, "0", "0");

            if (response) {
                const allAtendants = textTools.filterSelectedList(response.data, (_filter) ? _filter.attendantIds : []);
                resultList = [...resultList, ...allAtendants];
            }

            resultList = resultList
                .filter((item, index, self) => index === self.findIndex((i) => i.value === item.value))
                .sort((a, b) => (a.label > b.label ? 1 : -1));

            setAttendantList(resultList);
        }
        catch (err) {
            console.warn(err);
            // debugger;
        }

        setLoadingAttendants(false);
    }

    const applyFilters = (filterLocal?: any) => {
        let _currentFilter = (filterLocal) ? filterLocal : currentFilter;
        _currentFilter = {
            ..._currentFilter,
            businessAreaId: pref.businessAreaDash ?? 0
        };
        
        dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "filterSelected", value: _currentFilter } });

        if (!textTools.compareObjects(props.currentFilter, _currentFilter)) {
            // if (!textTools.compareObjects(filterLocal, currentFilter)) {
            props.setCurrentFilter(_currentFilter);
        }
    }

    const handleClear = () => {
        setClear(true);
        dispatch({ type: "PREF_BUSINESSAREA_DASH", payload: null });
        dispatch({ type: "PREF_SOLICITATIONTYPE_DASH", payload: null });
        dispatch({ type: "PREF_COMPETENCE_DASH", payload: null });
    }

    return (
        <>
            <HHExpand expanded={props.toggle} style={{ width: "100%", padding: "0px 10px" }}>
                {/* <div className={"row space-between"} style={{ marginBottom: 10 }}> */}
                <div className={"row start"} style={{ marginBottom: 10 }}>
                    {/* <div
                        style={{
                            display: "flex",
                            // width: "94%",
                            transition: "display ease-in 1s",
                            marginTop: "10px",
                            justifyContent: 'flex-start'
                        }}> */}

                    {/* <div style={{ display: "flex" }}> */}
                    {/* <div style={{ marginRight: "10px", width: "auto" }}> */}
                    <PPMultiSelect
                        openTrigger={"click"}
                        onChange={(event) => handleSelect(event, (currentFilter && currentFilter.dateTypes) ?? [])}
                        options={periodDate}
                        name={"dateTypes"}
                        placeholder={"Periodo"}
                        width={"150px"}
                        hideOptions
                    />
                    {/* </div> */}

                    {/* <div style={{ marginRight: "10px", width: "auto" }}> */}
                    <PPInput
                        type={"date"}
                        placeholder={"dd/mm/aaaa"}
                        width={"150px"}
                        name={"dataInicio"}
                        value={moment((currentFilter && currentFilter.dataInicio) ?? "").format("YYYY-MM-DD")}
                        onChange={handleDate}
                    />
                    {/* </div> */}

                    {/* <div style={{ marginRight: "10px", width: "auto" }}> */}
                    <PPInput
                        type={"date"}
                        placeholder={"dd/mm/aaaa"}
                        width={"150px"}
                        name={"dataFinal"}
                        value={moment((currentFilter && currentFilter.dataFinal) ?? "").format("YYYY-MM-DD")}
                        onChange={handleDate}
                    />
                    {/* </div> */}

                    <div style={{ width: "230px", display: 'flex', alignItems: 'center' }}>
                        <LcTooltip
                            content={"Ao filtrar pela versão mais recente, você eliminará dados duplicados e pesquisará pelo último status do chamado. Muito útil para casos onde o chamado passou por diferentes meses"}
                            trigger={"hover"}
                            children={
                                <PPToggle
                                    toggled={currentFilter.isCurrent}
                                    name={"Status mais recente"}
                                    title={"Status mais recente"}
                                    onChange={() => setCurrentFilter({ ...currentFilter, isCurrent: !currentFilter.isCurrent })}
                                />
                            }
                        />

                        <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />
                    </div>

                    <LcLoading loading={loadingCustomer} width={"auto"} height={"0px"}>
                        <PPMultiSelect
                            openTrigger={"click"}
                            onChange={(event) => handleSelect(event, (currentFilter && currentFilter.customerIds) ?? [])}
                            options={customerList}
                            name={"customerIds"}
                            placeholder={"Clientes"}
                            width={"150px"}
                            hideOptions
                        />
                    </LcLoading>

                    <LcLoading loading={loadingServiceGroup} width={"auto"} height={"0px"}>
                        <PPMultiSelect
                            openTrigger={"click"}
                            onChange={(event) => handleSelect(event, (currentFilter && currentFilter.groupServiceIds) ?? [])}
                            options={serviceGroupList}
                            name={"groupServiceIds"}
                            placeholder={"Grupos de serviço"}
                            width={"150px"}
                            hideOptions
                        />
                    </LcLoading>

                    <LcLoading loading={loadingService} width={"auto"} height={"0px"}>
                        <PPMultiSelect
                            openTrigger={"click"}
                            onChange={(event) => handleSelect(event, (currentFilter && currentFilter.serviceIds) ?? [])}
                            options={serviceList}
                            name={"serviceIds"}
                            placeholder={"Serviços"}
                            width={"150px"}
                            hideOptions
                        />
                    </LcLoading>
                    {/* </div> */}

                    {/* <div style={{ marginRight: "10px", width: "auto" }}>
                        <button
                            className={"lc-button bg-info-alt filter"}
                            children={"Aplicar"}
                            style={{ height: "28px", width: "100px" }}
                            onClick={() => applyFilters()}
                            color={"primary"}
                        />

                    </div> */}
                </div>

                <div className={"row space-between"}>
                    <div className={"row start"}>
                        <LcLoading loading={loadingProcess} width={"auto"} height={"0px"}>
                            <PPMultiSelect
                                openTrigger={"click"}
                                onChange={(event) => handleSelect(event, (currentFilter && currentFilter.processIds) ?? [])}
                                options={processList}
                                name={"processIds"}
                                placeholder={"Processos"}
                                width={"150px"}
                                hideOptions
                            />
                        </LcLoading>

                        <LcLoading loading={loadingTeams} width={"auto"} height={"0px"}>
                            <PPMultiSelect
                                openTrigger={"click"}
                                onChange={(event) => handleSelect(event, (currentFilter && currentFilter.teamIds) ?? [])}
                                options={allWorkTeam}
                                name={"teamIds"}
                                placeholder={"Equipes"}
                                width={"150px"}
                                hideOptions
                            />
                        </LcLoading>

                        <LcLoading loading={loadingAttendants} width={"auto"} height={"0px"}>
                            <PPMultiSelect
                                openTrigger={"click"}
                                onChange={(event) => handleSelect(event, (currentFilter && currentFilter.attendantIds) ?? [])}
                                options={attendantList}
                                name={"attendantIds"}
                                placeholder={"Atendentes"}
                                // right
                                width={"150px"}
                                hideOptions
                            />
                        </LcLoading>
                    </div >

                    <div style={{ display: "flex" }}>
                        {/* <LcIconLink icon={"ppi ppi-check"} onClick={() => applyFilters()} tooltip={"Aplicar filtros"} /> */}
                        <div className={"row space-between"}>
                            <button className={"lc-button bg-info"} disabled={loading} onClick={() => applyFilters()} children={"Aplicar"} />
                            <button className={"lc-button bg-info"} disabled={loading} onClick={() => handleClear()} children={"Limpar"} />

                            <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />

                            <LcDropDown
                                position={"Left"}
                                element={<LcIconLink icon={"ppi ppi-folder-open"} tooltip={"Mais filtros"} disabled={loading} />}
                                disabled={loading}
                                children={
                                    <>
                                        {
                                            (filtersList.length === 0)
                                                ? <span className={"item"}> Sem filtros salvos </span>
                                                : <>
                                                    {
                                                        filtersList.slice(0, 7).map(filter => {
                                                            return (
                                                                <span className={"item"} onClick={() => handleSelectedFilter(filter, filter.name, "select")}>{filter.name}</span>
                                                            )
                                                        })
                                                    }
                                                    <hr />
                                                    <span className={"item"} onClick={() => setOpenModalFilter(true)}>Mais Filtros</span>
                                                </>
                                        }
                                    </>
                                }
                            />

                            <LcIconLink
                                icon={"ppi ppi-save"}
                                onClick={() => setOpenNameFilter(!openNameFilter)}
                                tooltip={"Salvar filtros"}
                                tooltipPosition={"left"}
                                disabled={loading}
                            />
                        </div>
                    </div>
                </div>
            </HHExpand>

            <SideModal header={"Seus filtros"}
                visible={openModalFilter}
                onClose={() => setOpenModalFilter(false)}
            >
                <LcLoading loading={loadingFilters} label={"Carregando..."}>
                    <LcInfiniteTable
                        loading={loadingFilters}
                        columns={filterColumns}
                        rows={filtersList}
                        size={filtersList.length}
                        loadMore={() => { }}
                    />
                </LcLoading>
            </SideModal>

            <Modal
                title={"Salvar filtro"}
                visible={openNameFilter}
                close={() => setOpenNameFilter(false)}>
                <LcLoading loading={loadingSaveFilter}>
                    <PPTextField
                        required
                        onChange={(e) => setNewNameFilter(e.target.value)}
                        value={newNameFilter}
                        name={"name"}
                        label={"Nome do filtro"}
                        autoComplete={"off"}
                        help={validations.find(x => "name" === x.name)?.validateMessage}
                        error={validations.find(x => "name" === x.name) !== undefined}
                    />

                    <div className="row">
                        <button
                            style={{ margin: "10px" }}
                            className={"lc-button bg-info"}
                            id={"Ok"}
                            disabled={newNameFilter && newNameFilter.length > 0 ? false : true}
                            onClick={() => submitFilter()}
                            color={"primary"}>
                            Salvar
                        </button>
                        <button
                            style={{ margin: "10px" }}
                            className={"lc-button bg-info"}
                            id={"Cancelar"}
                            onClick={() => setOpenNameFilter(false)}
                            color={"primary"}>
                            Cancelar
                        </button>
                    </div>
                </LcLoading>
            </Modal>
        </>
    );
};

export default DashboardFilters;